<div class="loginCard">
  <div class="card border-0 px-5 py-5 py-md-0 px-md-4">
    <div class="card-body px-0 px-md-5">
      <div class="text-center">
        <img
          alt="Racebet365"
          src="../../../../../assets/media/logos/racebet365.png"
          width="270"
          class="my-5 img-fluid"
        />
      </div>
      <form [formGroup]="loginForm" autocomplete="off">
        <div class="form-group">
          <input
            id="username"
            class="borderInput p-inputtext-lg"
            type="text"
            formControlName="username"
            pInputText
            autocomplete="off"
            placeholder="{{ 'AUTH.INPUT.USERNAME' | translate }}"
          />
          <small
            *ngIf="isControlHasError('username', 'required')"
            class="text-danger"
          >
            {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
          >
          <small
            *ngIf="isControlHasError('username', 'minlength')"
            class="text-danger"
          >
            {{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</small
          >
          <small
            *ngIf="isControlHasError('username', 'maxlength')"
            class="text-danger"
          >
            {{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 100 32</small
          >
        </div>
        <div class="form-row mb-5 mb-md-4">
          <div class="col-12">
            <p-password
              name="password"
              formControlName="password"
              [toggleMask]="true"
              [feedback]="false"
              class="p-inputtext-lg"
              placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}"
            ></p-password>
            <small
              *ngIf="isControlHasError('password', 'required')"
              class="text-danger"
            >
              {{ "AUTH.VALIDATION.REQUIRED_FIELD" | translate }}</small
            >
            <small
              *ngIf="isControlHasError('password', 'minlength')"
              class="text-danger"
            >
              {{ "AUTH.VALIDATION.MIN_LENGTH_FIELD" | translate }} 3</small
            >
            <small
              *ngIf="isControlHasError('password', 'maxlength')"
              class="text-danger"
            >
              {{ "AUTH.VALIDATION.MAX_LENGTH_FIELD" | translate }} 10</small
            >
          </div>
        </div>
        <div class="mt-2" *ngIf="!isLoggedIn">
          <button
            class="btn btn-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center mb-3"
            (click)="submit()"
          >
            <i
              *ngIf="loading"
              class="pi pi-spin pi-spinner text-primary mr-2"
              style="font-size: 1.5rem"
            ></i>
            {{ "HOME.LOGIN_BUTTON_MODAL" | translate }}
          </button>
          <button
            class="btn btn-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center mb-3"
            (click)="handleReChaptra()"
            [disabled]="registrationBlocked"
          >
            {{ "ONE-CLICK REGISTRATION" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-outline-warning btn-md font-lg btn-block d-flex align-items-center justify-content-center mb-3"
            (click)="openRegisterPopup()"
            [disabled]="registrationBlocked"
          >
            {{ "AUTH.REGISTER.CREATE_BUTTON" | translate }}
          </button>
          <div *ngIf="registrationBlocked && registrationLimitMessage" class="registration-limit-notice mb-3">
            <i class="pi pi-exclamation-triangle"></i>
            <div class="registration-limit-notice-text">
              <p class="mb-1">{{ registrationLimitMessage }}</p>
              <small *ngIf="registrationLimitHelper">{{ registrationLimitHelper }}</small>
            </div>
          </div>
          <ng-container *ngIf="reChaptra && !registrationBlocked">
            <div class="form-group mb-3">
              <label for="country" style="color: #999">
                {{ 'CRYPTO.COUNTRY' | translate }}
              </label>
              <p-dropdown
                [options]="countries"
                [(ngModel)]="selectedCountryId"
                optionLabel="name"
                optionValue="id"
                class="w-100"
                (onChange)="onCountryChange($event)"
                [style]="{ width: '100%' }"
              >
                <ng-template let-country pTemplate="item">
                  <div class="d-flex align-items-center">
                    <img *ngIf="country.flag" [src]="country.flag" alt="" style="width: 20px; height: 14px; margin-right: 8px;" />
                    <span>{{ country.name }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="selectedItem">
                  <div class="d-flex align-items-center" *ngIf="selectedCountry">
                    <img *ngIf="selectedCountry.flag" [src]="selectedCountry.flag" alt="" style="width: 20px; height: 14px; margin-right: 8px;" />
                    <span>{{ selectedCountry.name }}</span>
                  </div>
                  <span *ngIf="!selectedCountry">{{ 'SELECT_COUNTRY' | translate }}</span>
                </ng-template>
              </p-dropdown>
            </div>
            <div class="form-group mb-3">
              <label for="currency" style="color: #999"
                >{{ 'CRYPTO.CURRENCY' | translate }}
              </label>
              <p-dropdown
                [options]="countries"
                class="w-100"
                [disabled]="true"
                [style]="{ width: '100%' }"
              >
                <ng-template pTemplate="selectedItem">
                  <div class="d-flex align-items-center" *ngIf="selectedCountry">
                    <span>{{ selectedCountry.currency }}</span>
                  </div>
                  <span *ngIf="!selectedCountry">{{ 'SELECT_CURRENCY' | translate }}</span>
                </ng-template>
              </p-dropdown>
            </div>
            <re-captcha
              (resolved)="resolved($event)"
              class="recaptcha-container"
              siteKey="{{ googleRecaptchaSiteKey }}"
            ></re-captcha>
          </ng-container>
        </div>
      </form>
    </div>

    <!-- One-click registration in flight: covers the card from the moment
         the captcha resolves until the popup hands over to the welcome
         modal (account creation + auto-login run behind it). -->
    <div class="registering-overlay" *ngIf="registering">
      <div class="registering-spinner">
        <i class="pi pi-spin pi-spinner"></i>
      </div>
      <div class="registering-title">
        {{ "AUTH.REGISTER.CREATING_TITLE" | translate }}
      </div>
      <div class="registering-sub">
        {{ "AUTH.REGISTER.CREATING_SUB" | translate }}
      </div>
    </div>
  </div>
</div>
